import React from "react";
import "../ProductCardsModems.css";
import { Link } from "react-router-dom"; 
import '../../i18n';
import { useTranslation } from 'react-i18next';

import ImageSpin12 from "../../assets/images/modems/processed/compact_spin12.png"

const Spin12_COMPACT = () => {
  const { t, i18n } = useTranslation();
  
  return (
      <Link to="/acoustic_modems#spin12_compact_spec" className="card-link-wrapper"> {/* Wrap card with Link */}
          <div className="card">
            <img src={ImageSpin12} alt={t('products.types.communcation_12_COMPACT.title')} className="card-image" />
            <div className="card-content">
              <h3 className="card-title">{t('products.types.communcation_12_COMPACT.title')}</h3>
              <p className="card-description">
                <ul class="features-list">
                  <li>{t('products.types.communcation_12_COMPACT.li_1')}</li>
                  <li>{t('products.types.communcation_12_COMPACT.li_2')}</li>
                  <li>{t('products.types.communcation_12_COMPACT.li_3')}</li>
                </ul>
              </p>
            </div>
          </div>
        </Link>
  );
};
export default Spin12_COMPACT;